var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSilverMedal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 32,
    viewBox: "0 0 30 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8028 1.376C13.6206 -0.259219 16.3794 -0.259219 18.1972 1.376L20.8963 3.80388C21.3932 4.2509 21.9784 4.58874 22.614 4.7956L26.0661 5.91912C28.3912 6.67582 29.7706 9.06496 29.2634 11.4569L28.5103 15.0083C28.3716 15.6622 28.3716 16.3378 28.5103 16.9917L29.2634 20.5431C29.7706 22.935 28.3912 25.3242 26.0661 26.0809L22.614 27.2044C21.9784 27.4113 21.3932 27.7491 20.8963 28.1961L18.1972 30.624C16.3794 32.2592 13.6206 32.2592 11.8028 30.624L9.1037 28.1961C8.60676 27.7491 8.0216 27.4113 7.38601 27.2044L3.93386 26.0809C1.60879 25.3242 0.229419 22.935 0.736629 20.5431L1.48971 16.9917C1.62836 16.3378 1.62836 15.6622 1.48971 15.0083L0.736629 11.4569C0.229419 9.06496 1.60879 6.67582 3.93386 5.91912L7.386 4.7956C8.0216 4.58874 8.60676 4.2509 9.1037 3.80389L11.8028 1.376Z",
    fill: "url(#paint0_linear_2174_38559)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2174_38559",
    x1: 15,
    y1: -1.5,
    x2: 15,
    y2: 33.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A0A3BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#696C84"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSilverMedal);
export default __webpack_public_path__ + "static/media/silver-medal.c32bef1f.svg";
export { ForwardRef as ReactComponent };